// extracted by mini-css-extract-plugin
export default {"SearchForApprovedContentsDialog":"SearchForApprovedContentsDialog_SearchForApprovedContentsDialog__466qM"};